/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import {useEffect, useState} from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {Box, Typography, Card, CardContent, useMediaQuery} from '@mui/material';

import {Thread} from '@jobseeker/lotus/assets/icons';

import {useDispatch, useSelector} from 'react-redux';
import {getDevice, getRefTagAndOrigin, trimText} from './homeCategory';
import {
  handleTracking,
  openUrl,
  TrackEventUBA,
} from '@jobseeker/common-core/utils';
import {Image} from '@jobseeker/lotus/components/Image';
import {AppState} from '@jobseeker/common-core/types';
import {loadAds} from '@jobseeker/common-core';
import Link from 'next/link';
export const getQueryParamsAndSeekerId = () => {
  const url = window.location.href;
  const urlObj = new URL(url);
  const queryParams = Object.fromEntries(urlObj.searchParams.entries());

  return {queryParams};
};
export const createAdvancedUrl = (title: any, jobId: any, type: any) => {
  return `/${type}/${trimText(title)}-${jobId}`;
};

const HomePageJobs = ({sortedJobs}: {sortedJobs: Array<object>}) => {
  // States for jobs and job rows
  const [jobs, setJobs] = useState<any[]>(sortedJobs);
  const [jobRows, setJobRows] = useState<any[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchJobs = async () => {
      const fetchedJobs = await loadAds(`5d70df5150d70a6ffe9a7eb5`);
      console.log({fetchedJobs});
      if (!fetchedJobs) {
        return;
      }
      const sortedJobs = fetchedJobs?.sort(
        (a: any, b: any) => parseInt(a.ordering, 10) - parseInt(b.ordering, 10)
      );

      setJobs(sortedJobs);
    };

    if (!(jobs?.length > 0)) {
      fetchJobs();
    }
  }, []);

  const isSmallScreen = useMediaQuery('(max-width:599px)');
  const isMediumScreen = useMediaQuery(
    '(min-width:600px) and (max-width:767px)'
  );
  const isLargeScreen = useMediaQuery(
    '(min-width:1024px) and (max-width:1279px)'
  );

  const isLargerScreen = useMediaQuery(
    '(min-width:1280px) and (max-width:1400px)'
  );

  const calculateSlides = () => {
    if (isMediumScreen || isLargeScreen) {
      return 2;
    } else if (isSmallScreen) {
      return 1;
    }
    return 3; // Default for larger screens
  };

  const {userId, isLoggedIn} = useSelector((state: AppState) => state.auth);

  const handleUbaTracking = (eventName: any, section: string, jobId: any) => {
    const {queryParams} = getQueryParamsAndSeekerId();
    TrackEventUBA(eventName, 'click', {
      page: 'jsHomePage',
      ref: queryParams.ref || '',
      section: section,
      jobId: jobId.toString() || '',
      sessionUsername: userId ? userId.toString() : '',
    });
  };
  const useUserAgent = () => {
    const [userAgent, setUserAgent] = useState<string>('');

    useEffect(() => {
      if (typeof navigator !== 'undefined') {
        setUserAgent(navigator.userAgent || navigator.vendor || '');
      }
    }, []);

    return userAgent;
  };
  const userAgent = useUserAgent();
  const device = getDevice(userAgent);

  const slides = calculateSlides();
  const handleCompanyLogoClick = (jobId: any) => {
    const {origin, refText} = getRefTagAndOrigin();

    handleTracking('jsClickPremiumJobLogo', {
      event_category: 'jsHomePage',
      Source: `${origin}`,
      Device: sessionStorage.getItem('device') || 'desktop',
      Ref: `${refText}`,
      Jobid: `${jobId}`,
    });

    handleUbaTracking('jsPremiumJobClick', 'JobLogo', jobId);
    // handleUbaTracking('jsPremiumJobLogoClick', jobId);
  };
  const handleCompanyBannerClick = (jobId: any) => {
    const {origin, refText} = getRefTagAndOrigin();
    handleTracking('jsClickPremiumJobBanner', {
      event_category: 'jsHomePage',
      Source: `${origin}`,
      Device: sessionStorage.getItem('device') || 'desktop',
      Ref: `${refText}`,
      Jobid: `${jobId}`,
    });
    handleUbaTracking('jsPremiumJobClick', 'Banner', jobId);
  };

  useEffect(() => {
    if (jobs && jobs.length > 0) {
      const calculatedRows = [...Array(Math.ceil(jobs.length / slides))];
      const calculatedJobRows = calculatedRows.map((_, idx) =>
        jobs.slice(idx * slides, slides + idx * slides)
      );

      setJobRows(calculatedJobRows);
    }
  }, [jobs, slides]);
  const CustomPrevArrow = (props: any) => {
    const {onClick, currentSlide} = props;
    const {origin, refText} = getRefTagAndOrigin();
    const isDisabled = currentSlide === 0;
    return (
      <div
        style={{
          position: 'absolute',
          left: isSmallScreen
            ? '36%'
            : isLargeScreen
            ? '-42%'
            : isLargerScreen
            ? '-42%'
            : '-35%', // Adjust position as needed
          top: isSmallScreen
            ? '105%'
            : isLargeScreen
            ? '84%'
            : isLargerScreen
            ? '62%'
            : '64%',
          transform: 'translateY(-50%)',
          zIndex: 1,
          cursor: 'pointer',
        }}
        onClick={() => {
          handleUbaTracking('jsPremiumJobClick', 'JobScroll', '');
          handleTracking('jsClickPremiumJobScroll', {
            event_category: 'jsHomePage',
            Source: origin,
            Device: sessionStorage.getItem('device') || 'desktop',
            Ref: refText.toString(),
          });
          onClick();
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="17"
          viewBox="0 0 22 17"
          fill="none"
        >
          <path
            d="M0.319616 7.40275L7.3029 0.419465C7.72897 -0.00660232 8.41996 -0.00660232 8.84603 0.419465C9.27218 0.84562 9.27218 1.53644 8.84603 1.9626L3.72545 7.08318H20.9089C21.5114 7.08318 22 7.57174 22 8.17431C22 8.7768 21.5114 9.26545 20.9089 9.26545H3.72545L8.84585 14.386C9.27201 14.8122 9.27201 15.503 8.84585 15.9292C8.63286 16.1421 8.35353 16.2487 8.07429 16.2487C7.79505 16.2487 7.5158 16.1421 7.30272 15.9292L0.319616 8.94588C-0.106539 8.51972 -0.106539 7.8289 0.319616 7.40275Z"
            fill={isDisabled ? 'rgba(0, 0, 0, 0.2)' : '#E9630C'}
          />
        </svg>{' '}
      </div>
    );
  };

  // Custom Next Arrow Component
  const CustomNextArrow = (props: any) => {
    const {onClick, currentSlide, slideCount, slidesToShow} = props;
    const {origin, refText} = getRefTagAndOrigin();
    const isDisabled = currentSlide + slides >= slideCount;
    return (
      <div
        style={{
          position: 'absolute',
          left: isSmallScreen
            ? '51%'
            : isLargeScreen
            ? '-32%'
            : isLargerScreen
            ? '-34%'
            : '-28%', // Adjust position as needed
          top: isSmallScreen
            ? '105%'
            : isLargeScreen
            ? '84%'
            : isLargerScreen
            ? '62%'
            : '64%',
          transform: 'translateY(-50%)',
          zIndex: 1,
          cursor: 'pointer',
        }}
        onClick={() => {
          handleUbaTracking('jsPremiumJobClick', 'JobScroll', '');
          handleTracking('jsClickPremiumJobScroll', {
            event_category: 'jsHomePage',
            Source: origin,
            Device: sessionStorage.getItem('device') || 'desktop',
            Ref: refText.toString(),
          });
          onClick();
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="17"
          viewBox="0 0 22 17"
          fill="none"
        >
          <path
            d="M21.6804 7.57098L14.6971 0.428986C14.271 -0.00676486 13.58 -0.00676486 13.154 0.428986C12.7278 0.864826 12.7278 1.57135 13.154 2.00719L18.2745 7.24414H1.09114C0.488568 7.24414 0 7.74382 0 8.36008C0 8.97626 0.488568 9.47602 1.09114 9.47602H18.2745L13.1541 14.713C12.728 15.1488 12.728 15.8553 13.1541 16.2912C13.3671 16.5089 13.6465 16.618 13.9257 16.618C14.205 16.618 14.4842 16.5089 14.6973 16.2912L21.6804 9.14918C22.1065 8.71334 22.1065 8.00682 21.6804 7.57098Z"
            fill={isDisabled ? 'rgba(0, 0, 0, 0.2)' : '#E9630C'}
          />
        </svg>{' '}
      </div>
    );
  };
  const sliderSettings = {
    dots: false,
    infinite: false,
    variableWidth: true,
    speed: 500,
    slidesToShow: slides, // Example: Show 3 slides
    slidesToScroll: slides, // Example: Scroll by 3 slides
    adaptiveHeight: true,
    arrows: true, // Enable arrows
    prevArrow: <CustomPrevArrow />, // Custom previous arrow
    nextArrow: <CustomNextArrow />, // Custom next arrow
  };
  const [hoverId, setHover] = useState<any>(-1);

  const handleJobClickTracking = (jobId: any) => {
    const {origin, refText} = getRefTagAndOrigin();
    handleTracking('jsClickPremiumViewJob', {
      event_category: 'jsHomePage',
      Source: `${origin}`,
      Device: sessionStorage.getItem('device') || 'desktop',
      Ref: `${refText}`,
      Jobid: `${jobId}`,
    });
  };
  // Job card content
  const content = jobs?.map((job: any) => (
    <Card
      key={job.jobId}
      sx={{
        cursor: 'pointer',
        height: '310px',
        width: {
          xxs: '280px !important',
          md: '290px !important',
          lg: '250px !important',
          xl: '265px !important',
        },
        marginRight: '20px',
        marginBottom: '20px',
        borderRadius: '8px',
        border: '1px solid #efefef',
        boxShadow: '0 2px 30px 0 rgba(0, 0, 0, 0.06) !important',
        overflow: 'visible',
        ':hover': {
          boxShadow: 'none !important',
        },
      }}
      onMouseEnter={() => setHover(job.jobId)}
      onMouseLeave={() => setHover(-1)}
    >
      <div
        style={{
          height: '140px',
          overflow: 'hidden',
          borderTopRightRadius: '8px',
        }}
      >
        <Image
          height="197px"
          width={isSmallScreen ? '280px !important' : '290px !important'}
          style={{
            overflow: 'hidden',
            borderTopRightRadius: '8px',
            borderTopLeftRadius: '8px',
          }}
          className="slide-company-logo"
          src={job.imageUrl}
          alt={job.title}
          onClick={() => handleCompanyBannerClick(job['jobId'])}
        />
      </div>
      <Image
        style={{marginLeft: '16px', marginTop: '17px', height: '30px'}}
        className="slide-company-logo"
        src={job.companyLogo}
        alt={job.tTitle}
        onClick={() => handleCompanyLogoClick(job['jobId'])}
      />
      <a
        href={`${createAdvancedUrl(job.title, job['jobId'], 'j')}?ref=hpjob`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          handleJobClickTracking(job['jobId']);
          handleUbaTracking('jsPremiumJobClick', 'ViewJob', job['jobId']);
        }}
        style={{textDecoration: 'none', color: '#000'}}
      >
        <CardContent sx={{padding: 0}}>
          <Typography
            sx={{
              fontSize: '15px',
              fontWeight: 600,
              height: '50px',
              fontFamily: 'Nunito Sans',
              marginBottom: '7px',
              paddingLeft: '10px',
              paddingTop: '16px',
              paddingRight: '16px',
            }}
          >
            {job.title.split('(')[0].substring(0, 50)}
            {job.title.split('(')[0].length > 50 ? '...' : ''}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              paddingTop: 1,
              paddingLeft: 1.25,
            }}
          >
            <Typography
              sx={{
                color: 'rgba(0,0,0,0.7)',
                fontFamily: 'Nunito Sans',
                fontSize: '14px',
                fontWeight: 300,
                width: '116px',
                overflow: 'hidden',

                whiteSpace: 'nowrap', // Ensures the text stays on a single line
                textOverflow: 'ellipsis',
              }}
            >
              {job.location
                .map((l: any) => l.name)
                .join('/')
                .replace('Anywhere in India/', '')}
            </Typography>
            <span
              style={{
                display: 'inline-block',
                width: '3px',
                height: '4px',
                backgroundColor: '#cecece',
                marginLeft: isLargerScreen
                  ? '8px'
                  : isLargeScreen || isSmallScreen
                  ? '12px'
                  : '8px',
                marginRight: isLargerScreen
                  ? '11px'
                  : isLargeScreen || isSmallScreen
                  ? '12px'
                  : '15px',
                borderRadius: '50%',
                marginBottom: '3px',
              }}
            ></span>
            <Typography
              variant="body2"
              sx={{
                color: 'rgba(0,0,0,0.7)',
                fontFamily: 'Nunito Sans',
                fontSize: '14px',
                fontWeight: 300,
                marginLeft: -1,
              }}
            >
              {job.minExp} - {job.maxExp} Years
            </Typography>
          </Box>
          {hoverId === job['jobId'] ? (
            <Box
              sx={{
                width: '90px',
                height: '34px',
                borderRadius: '4px',
                backgroundColor: ' #e9630c',
                lineHeight: '22px',
                fontSize: '16px',
                textSlign: 'center',
                color: ' #ffffff !important',
                cursor: 'pointer',
                paddingTop: '6px',
                // position: 'absolute',
                bottom: ' 0px',
                paddingLeft: '12px',
                marginTop: '16px',
                marginLeft: '16px',
                overflow: 'visible',
                zIndex: 6,
                backgroundPositionY: 'absolute',
                left: '18px',
              }}
            >
              View Job
            </Box>
          ) : (
            <></>
          )}
        </CardContent>
      </a>
    </Card>
  ));

  return (
    <Box
      sx={{
        padding: {xxs: 0, md: '42px 0px 57px 58px'},
        paddingRight: 0,
        mt: {xxs: 9, md: 0},

        position: 'relative',
      }}
    >
      <Box
        sx={{
          width: {xxs: '100%', md: '30%', lg: '30%', xl: '26%'},
          paddingRight: '3%',
          display: 'inline-block',
        }}
      >
        <Box display={'flex'} ml={{xxs: 4, md: 0}} mb={1}>
          <Image
            src={Thread}
            alt="j"
            width="4"
            height="18"
            style={{marginRight: '2px'}}
          />
          <Image
            src={Thread}
            alt="j"
            width="4"
            height="18"
            style={{marginRight: '2px'}}
          />
          <Image
            src={Thread}
            alt="j"
            width="4"
            height="18"
            style={{marginRight: '2px'}}
          />
        </Box>
        {isSmallScreen ? (
          <Typography
            component={'h2'}
            sx={{
              fontSize: '32px',
              fontWeight: {xxs: 500, md: 500},
              lineHeight: '43px',
              fontFamily: 'Nunito Sans',
              ml: {xxs: '30px', md: 0},
              mb: 1,
            }}
          >
            Premium <b>Handpicked</b> <br></br>jobs for you
          </Typography>
        ) : (
          <Typography
            component={'h2'}
            sx={{
              fontSize: '32px',
              fontWeight: {xxs: 500, md: 500},
              lineHeight: '43px',
              fontFamily: 'Nunito Sans',
              ml: {xxs: '30px', md: 0},
              mb: 1.5,
            }}
          >
            Premium <b>Handpicked</b> {!isLargeScreen ? <br></br> : <></>} jobs{' '}
            {isLargeScreen ? <br></br> : <></>} for you
          </Typography>
        )}

        <Typography
          variant="body1"
          sx={{
            fontSize: '20px',
            fontWeight: 300,
            color: 'rgba(0,0,0,0.5)',
            fontFamily: 'Nunito Sans',
            display: {xxs: 'none', md: 'inline'},
          }}
        >
          Premium handpicked jobs that you will not find anywhere else!
        </Typography>
      </Box>
      <Box
        sx={{
          width: {md: '70%', xxs: '93%', lg: '70%', xl: '74%'},
          display: 'inline-block',
          verticalAlign: 'top',
          marginLeft: {xxs: '24px', md: 0},
        }}
      >
        <Slider {...sliderSettings}>{content}</Slider>
      </Box>
    </Box>
  );
};

export default HomePageJobs;
